import { useContext } from 'react';
import { ActionSheetContext } from "$uikit/ActionSheet/ActionSheet";

export const useActionSheet = () => useContext(ActionSheetContext).active;
